import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareSquare } from '@fortawesome/free-solid-svg-icons';
import { RWebShare } from "react-web-share";

const styles = {
  card: {
    minWidth: 275,
    width: 'auto'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 18,
  },
  pos: {
    marginBottom: 12,
  },
};

function CardCurrentConditions(props) {
  const { classes, spot } = props;
  const WARM_WETSUIT = '3/2'
  const COLD_WETSUIT = '4/3'

  const formatDate = (value1) => {

    const date1 = new Date(value1)

    const formattedDate = date1.toLocaleString("en-US", {})

    return formattedDate;
  }

  const wetsuit = (waterTemp) => {

    if (waterTemp > 58)
      return WARM_WETSUIT + "mm"
    else
      return COLD_WETSUIT + "mm"
  }
  
  return (
    
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title}>
          
          <span>Surf in My Area ({spot.spotName}) </span>
          <span className="float-right">
            <RWebShare
                data={{
                    text: "Let's go surf?",
                    url: "https://surf-spots-ui.vercel.app",
                    title: "Surf Alert!",
                }}>
                <Link>
              <FontAwesomeIcon size="lg" icon={faShareSquare} className="fa-duotone" />
              </Link>
            </RWebShare>
          </span>
          </Typography>
        
          <div>
            <Grid container spacing={3}>
                <Grid item >
                <div style={{ color: spot.score, fontSize: 54, fontStyle: 'bold' }}> {spot.waveHeight}
                <span style={{ color: spot.score, fontSize: 24  }}> ft</span></div>
                
                </Grid>
                <Grid item >
                <div >
                    <div style={{ color: "grey" }}> Period : {spot.wavePeriod + " s"}</div>
                    <div style={{ color: "grey" }}> Water Temp : {spot.waterTemp}°F</div>
                    <div style={{ color: "grey" }}> Wetsuit : {wetsuit(spot.waterTemp)}</div>
                    <div style={{ color: "grey" }}> Direction : {spot.compassDirection}</div>
                    <div style={{ color: "green", maxInlineSize:"200px", fontSize: 10 }}> Updated : {formatDate(spot.last_udpate)} </div>
                    <div style={{ color: "green", maxInlineSize:"200px", fontSize: 10 }}> Location : {spot.spotName} [Station:{spot.noaa_station_id_realtime}]</div>
                </div>
                </Grid>
           
            </Grid>
          </div>
        </CardContent>
      </Card>
  
  );
}

CardCurrentConditions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardCurrentConditions);
